import combineReducers from 'combine-reducers-global-state';
import user from './users';
import auth from './auth';
import ui from './ui';
import utils from './utils';
import region from './region';
import securityCompany from './securityCompany';
import globalList from './globalList';
import { connectRouter } from 'connected-react-router';
import { reducer as globalReducer } from 'slices/globalOptions';
import { reducer as themeReducer } from 'slices/themes';
import {
  reducers as cleaningReducer,
  reducerKey as cleanerTaskReducerKey,
} from 'containers/Pages/Tasks/CleanerTasks';
import {
  reducers as securityReducer,
  reducerKey as securityReducerKey,
} from 'containers/Pages/Tasks/Security';
import {
  reducers as taskTypeReducer,
  reducerKey as taskTypeReducerKey,
} from 'containers/Pages/Tasks/TaskTypes';
import {
  reducers as templateReducer,
  reducerKey as templateTaskReducerKey,
} from 'containers/Pages/Tasks/Template';
import {
  reducers as personnelReducer,
  reducerKey as personnelReducerKey,
} from 'containers/Pages/People/Personnel';
import {
  reducers as businessClientsReducer,
  reducerKey as businessClientsReducerKey,
} from 'containers/Pages/People/BusinessClients';
import {
  reducers as customersReducer,
  reducerKey as customersReducerKey,
} from 'containers/Pages/People/Customers';
import {
  reducers as departmentsReducer,
  reducerKey as departmentsReducerKey,
} from 'containers/Pages/People/Departments';
import {
  reducers as zonesReducer,
  reducerKey as zonesReducerKey,
} from 'containers/Pages/Locations/Zones';
import {
  reducers as visitorsReducer,
  reducerKey as visitorsReducerKey,
} from 'containers/Pages/Locations/Visitors';
import {
  reducers as visitorTypesReducer,
  reducerKey as visitorTypesReducerKey,
} from 'containers/Pages/Locations/VisitorTypes';
import {
  reducers as sitesReducer,
  reducerKey as sitesReducerKey,
} from 'containers/Pages/Locations/Sites';
import {
  reducers as assetTypesReducer,
  reducerKey as assetTypesReducerKey,
} from 'containers/Pages/Assets/AssetTypes';
import {
  reducers as patrolTemplateReducer,
  reducerKey as patrolTemplateReducerKey,
} from 'containers/Pages/Tasks/PatrolTemplates';
import {
  reducers as emergencyReducer,
  reducerKey as emergencyReducerKey,
} from 'containers/Pages/Tasks/Emergencies';
import {
  reducers as tripReducer,
  reducerKey as tripReducerKey,
} from 'containers/Pages/Tasks/Trips';
import {
  reducers as assetReducer,
  reducerKey as assetReducerKey,
} from 'containers/Pages/Assets/Assets';
import {
  reducers as eventsReducer,
  reducerKey as eventsReducerKey,
} from 'containers/Pages/Events';
import {
  reducers as eventTypesReducer,
  reducerKey as eventTypesReducerKey,
} from 'containers/Pages/Admin/EventTypes';
import {
  reducer as embeddedFormReducer,
  embeddedFormNS,
} from 'modules/embeddedForms/reducer';
import {
  reducers as messagesReducer,
  reducerKey as messagesReducerKey,
} from 'containers/Pages/Messages';
import {
  reducers as attendanceReducer,
  reducerKey as attendanceReducerKey,
} from 'containers/Pages/People/Attendance';
import {
  reducers as patrolTaskReducers,
  reducerKey as patrolTaskReducerKey,
} from 'containers/Pages/Tasks/Patrols';
import {
  reducers as workOrdersReducers,
  reducerKey as workOrdersReducerKey,
} from 'containers/Pages/Tasks/WorkOrders';
import {
  reducers as tripTypeReducers,
  reducerKey as tripTypeReducerKey,
} from 'containers/Pages/Tasks/TripTypes';
import {
  reducers as companyReducer,
  reducerKey as companyReducerKey,
} from 'containers/Pages/Region/Companies';
import {
  reducers as pendingCompanyReducer,
  reducerKey as pendingCompanyReducerKey,
} from 'containers/Pages/Region/PendingCompany';
import {
  reducers as calendarReducers,
  reducerKey as calendarReducerKey,
} from 'containers/Pages/CalendarUI';
import {
  reducers as regionReducers,
  reducerKey as regionReducerKey,
} from 'containers/Pages/Region/Region';

const createRootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    globalList,
    user,
    auth,
    ui,
    utils,
    region,
    securityCompany,
    globalOptions: globalReducer,
    theme: themeReducer,
    //tasks
    [templateTaskReducerKey]: templateReducer,
    [taskTypeReducerKey]: taskTypeReducer,
    [cleanerTaskReducerKey]: cleaningReducer,
    [patrolTemplateReducerKey]: patrolTemplateReducer,
    [emergencyReducerKey]: emergencyReducer,
    [tripReducerKey]: tripReducer,
    [securityReducerKey]: securityReducer,
    //People
    [personnelReducerKey]: personnelReducer,
    [businessClientsReducerKey]: businessClientsReducer,
    [customersReducerKey]: customersReducer,
    [departmentsReducerKey]: departmentsReducer,
    [attendanceReducerKey]: attendanceReducer,
    //Locations
    [zonesReducerKey]: zonesReducer,
    [visitorsReducerKey]: visitorsReducer,
    [visitorTypesReducerKey]: visitorTypesReducer,
    //Assets
    [assetTypesReducerKey]: assetTypesReducer,
    [assetReducerKey]: assetReducer,
    //events
    [eventsReducerKey]: eventsReducer,
    [eventTypesReducerKey]: eventTypesReducer,
    //messaging
    [messagesReducerKey]: messagesReducer,
    //sites
    [sitesReducerKey]: sitesReducer,
    //Region
    [pendingCompanyReducerKey]: pendingCompanyReducer,
    //embeddedForms
    [embeddedFormNS]: embeddedFormReducer,
    // patrolTasks
    [patrolTaskReducerKey]: patrolTaskReducers,
    [workOrdersReducerKey]: workOrdersReducers,
    [tripTypeReducerKey]: tripTypeReducers,
    [calendarReducerKey]: calendarReducers,
    [companyReducerKey]: companyReducer,
    [regionReducerKey]: regionReducers,
  });

export default createRootReducer;
